import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './keto-about.module.css';
import KetoContainer from './keto-container';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoAbout() {
  return (
    <section className={styles.about}>
      <KetoContainer>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.about_inner}
        >
          <div className={styles.about_start}>
            <Image
              width={740}
              height={616}
              src="/keto/about/about.png"
              alt="Keto kitchen app screens"
            />
          </div>
          <div className={styles.about_end}>
            <KetoTypography
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
              className={styles.about_title}
            >
              The Main Idea
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.about_text}
                tag="p"
                variant={KetoTypographyVariant.BODY_2}
              >
                Our main goal was to make your Keto life easier, tastier and
                more delicious with the variety of Low Carb recipes that
                we&apos;d collected and organized in categories for your
                convenience.
              </KetoTypography>
              <KetoTypography
                className={styles.about_text}
                tag="p"
                variant={KetoTypographyVariant.BODY_2}
              >
                Wether you&apos;re looking for a dish to pamper your kid or for
                an interesting sauce to your steak portion, if need a new idea
                for a simple brunch or you&apos;re planning a healthy family
                dinner, our Keto Kitchen is always in your pocket!
              </KetoTypography>
            </KetoPaper>
          </div>
        </AnimationOnScroll>
      </KetoContainer>
    </section>
  );
}
